import React from 'react';
import { DialogProps } from '../../ui';
import { ExitIcon } from '../../icons';
import { DrawerModal } from '../drawer-modal';

export interface CancelCallModalProps extends Omit<DialogProps, 'onClose'> {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  listenerName?: string;
  dataTestId?: string;
  isCancelling?: boolean;
}

export const CancelCallModal: React.FC<CancelCallModalProps> = ({
  onClose,
  onConfirm,
  listenerName,
  dataTestId,
  isCancelling = false,
  open,
}: CancelCallModalProps) => {
  const header = (
    <div className="flex items-center justify-between">
      <h2 className="font-albert-sans text-2xl font-semibold leading-[30px] tracking-[-0.2px] text-black">
        Cancel call
      </h2>
      <button
        onClick={onClose}
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
        aria-label="Close modal"
        disabled={isCancelling}
      >
        <ExitIcon color="#22282F" />
      </button>
    </div>
  );

  const footer = (
    <div className="flex w-full flex-col gap-3">
      <button
        type="button"
        onClick={onClose}
        disabled={isCancelling}
        className="bg-button-primary hover:bg-button-primary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 text-white transition-colors disabled:cursor-not-allowed disabled:opacity-50"
      >
        Keep call
      </button>
      <button
        type="button"
        onClick={onConfirm}
        disabled={isCancelling}
        className="bg-button-secondary hover:bg-button-secondary-hover text-button-primary inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 font-['Open_Sans'] text-base font-medium leading-5 transition-colors disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isCancelling ? 'Cancelling...' : 'Cancel call'}
      </button>
    </div>
  );

  return (
    <DrawerModal
      open={open}
      onClose={onClose}
      header={header}
      footer={footer}
      maxWidth="max-w-md"
      className="shadow-modal"
    >
      <div className="px-6 py-6">
        <p className="font-['Open_Sans'] text-sm font-normal leading-6 text-gray-700">
          {listenerName
            ? `Are you sure you want to cancel your scheduled call with ${listenerName}?`
            : 'Are you sure you want to cancel this scheduled call?'}
        </p>
      </div>
    </DrawerModal>
  );
};
